import React from "react";
import CodeSnippet from "../index-sections/CodeSnippet.js";

import {
  Button,
  Container,
  Row,
  Col,
} from "reactstrap";

import Navbar from "components/Navbars/IndexNavbar";
import Header from "components/Headers/IndexHeader";
import Footer from "components/Footers/DemoFooter.js";

function RiceverePaginaHtml() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("profile-page");
    return function cleanup() {
      document.body.classList.remove("profile-page");
    };
  });
  return (
    <>
        {/* Navbar */}
        <Navbar />

        {/* Header */}
        <Header />
        
        {/* Inizio del contenuto della pagina */}
        <div className="main">
            <div className="section text-center">
                {/* Inizio del container */}
                <Container>
                    <Row>
                        <Col className="ml-auto mr-auto" md="8">
                            {/* Titolo */}
                            <h2 className="title">Ricevere Pagina HTML</h2>
                            {/* Descrizione */}
                            <h5 className="description" style={{color: 'black'}}>
                                Il primo esercizio utile per imparare la comunicazione di client-server di Node.js è quello di andare a ricavare il contenuto di una pagina HTML
                            </h5>
                            <br />
                        </Col>
                    </Row>
                </Container>
                {/* Fine del container */}
                
                {/* INIZIO CODICE HTML */}
                {/* Inizio snippet del codice */}
                <CodeSnippet
                    language="html"
                    description="Come prime cosa andiamo a creare la nostra pagina HTML (index.html) che successivamentre andremo a ricevere dal server (server.js).
                    Nel mio caso sono andato ad inserire un testo, un link di collegamento e un'immagine"
                    code={`<body>
    Loreim ipsum
    <br/>
    <a href="https://www.formula1.com/">Formula 1</a>
    <br/>
    <img src="{linkImmagine}" alt="" title="Foto Lancia Stratos">
</body>`}
                />
                {/* Fine snippet del codice */}
                {/* FINE CODICE HTML */}

                {/* INIZIO CODICE JAVASCRIPT */}
                {/* Inizio snippet del codice */}
                <CodeSnippet
                    language="javascript"
                    description="Dopo aver importato i moduli per l'HTTP e per il File System vado prima a settare il contenuto del testo come 'text-html' e poi a ricavare attraverso la funzione 'readFileSync' del modulo 'FS' il contenuto della pagina HTML (index.html) che verrà memorizzato all'interno della variabile 'contenutoFile'. Per concludere vado a mettere come messaggio finale di risposta (res.end) il contenuto della variabile contenutoFile (ovvero il contenuto della mia pagina index.html)"
                    code={`//IMPORTO IL MODULO HTTP E FS
let mioServer = require("http")
let fs = require("fs")

//CREO IL SERVER CHE RIMANE IN ASCOLTO SULLA PORTA 3000
mioServer.createServer((req, res) => {

    //SETTO L'HEADER PRIMA DI INVIARE IL PACCHETTO
    res.setHeader("content-type", "text/html")
    let contenutoFile = fs.readFileSync("./index.html")
    
    //MESSAGGIO DI RISPOSTA DAL SERVER
    res.end(contenutoFile)
}).listen(3000)`}
                />
                {/* Fine snippet del codice */}
                {/* FINE CODICE JAVASCRIPT */}

            </div>

            {/* Inizio button per codice completo */}
            <div className="section text-center">
                <Button className="btn-round mr-1" color="info" outline type="button" href="https://github.com/MattiaBracco05/SCUOLA/tree/494a02a630bb3d1ee07a766e7f6b7da945d9c41b/5L/TPSIT/Node%20JS/ricevere_pagina_html" target="_blank">
                    Visualizza codice completo
                </Button>
            </div>
            {/* Fine button per codice completo */}
            
        </div>
        {/* Fine del contenuto della pagina */}
        
        {/* Footer */}
        <Footer />
    </>
  );
}

export default RiceverePaginaHtml;
